/**
 * Ações cuja projeção de dividendos é publicada em outro ticker da mesma empresa
 * (sem o sufixo ".SA"). Ex.: ITUB4 usa a projeção de ITUB3.
 */
const FORECAST_TICKER_ALIASES: Record<string, string> = {
  ITUB4: 'ITUB3',
  ITSA3: 'ITSA4',
  PETR3: 'PETR4',
  KLBN3: 'KLBN11',
  KLBN4: 'KLBN11',
  TAEE3: 'TAEE11',
  TAEE4: 'TAEE11',
  GOAU3: 'GOAU4',
  AXIA3: 'AXIA6',
};

/**
 * Quantas ações avulsas equivalem a uma unit, para dividir a projeção da unit
 * e chegar no dividendo por ação. Ex.: 1 KLBN11 = 5 ações KLBN3/KLBN4.
 */
const UNIT_SHARE_RATIOS: Record<string, number> = {
  'KLBN3.SA': 5,
  'KLBN4.SA': 5,
  'TAEE3.SA': 3,
  'TAEE4.SA': 3,
  'AXIA3.SA': 1.111111111,
};

/** Ticker (sem ".SA") onde está a projeção de dividendos deste ativo. */
export function getForecastTicker(ticker: string): string {
  return FORECAST_TICKER_ALIASES[ticker] ?? ticker;
}

/** Converte o dividendo projetado da unit para dividendo por ação, com 2 casas. */
export function toDividendPerShare(ticker: string, dividend: string): string {
  const ratio = UNIT_SHARE_RATIOS[ticker] ?? 1;

  return (Number(dividend) / ratio).toFixed(2);
}
